import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Box, TextField, Autocomplete } from '@mui/material';

import { setSelectedCustomer } from '../../redux/actions/Account';
import api from '../../api';
import { nexwayStateSelector } from '../../redux/selectors/Account';

import '../../styles/main.scss';

const CustomerHandling = () => {
  const dispatch = useDispatch();
  const [customers, setCustomers] = useState([]);
  const [accountCustomer, setAccountCustomer] = useState({});
  const [search, setSearch] = useState(null);
  const account = useSelector(({ account: { user } }) => user);
  const accountId = account?.customerId;
  const { selectedCustomer, recentCustomers } = useSelector(nexwayStateSelector);

  useEffect(() => {
    api.getCustomersByName().then(({ data: { items } }) => {
      setCustomers(items);

      const accountCustomerData = items?.find((i) => i?.id === accountId);

      if (accountCustomerData) {
        setAccountCustomer({
          id: accountCustomerData?.id,
          name: accountCustomerData?.name,
          group_type: 'Account',
        });

        !selectedCustomer?.id && dispatch(setSelectedCustomer({
          ...accountCustomerData,
          group_type: 'Current',
        }));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => search && api
      .getCustomersByName(search)
      .then(({ data: { items } }) => {
        setCustomers([...items]);
      }),
    300);

    return () => clearTimeout(timer);
  }, [search]);

  const options = useMemo(
    () => {
      const opt = [];

      accountCustomer?.id && opt.push(accountCustomer);
      selectedCustomer?.id && selectedCustomer?.id !== accountCustomer.id && opt.push(selectedCustomer);
      recentCustomers?.length && opt.push(...recentCustomers);
      customers?.length && opt.push(...customers);

      return opt;
    },
    [accountCustomer, customers, recentCustomers, selectedCustomer],
  );

  const eraseSearch = () => setSearch(null);

  const handleChangeCustomer = (e, selected) => {
    e.persist();

    eraseSearch();
    dispatch(
      setSelectedCustomer(selected
        ? {
          ...selected,
          group_type: 'Current',
        }
        : selected),
    );
  };

  const handleInputChange = (e) => {
    e.persist();
    setSearch(e.target.value);
  };

  const handleEqual = (option) => option.id === selectedCustomer?.id;
  const handleFilterOptions = (opts) => opts.filter(
    ({ name = '' }) => typeof search !== 'string' || name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    customers && (
      <Box
        width="100%"
        m="auto"
        p="0 3px"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        className="customers-handling"
      >
        <Autocomplete
          id="customers-select"
          options={options}
          inputValue={search ?? (selectedCustomer?.name || '')}
          value={selectedCustomer?.id || null}
          onBlur={eraseSearch}
          isOptionEqualToValue={handleEqual}
          onChange={handleChangeCustomer}
          filterOptions={handleFilterOptions}
          groupBy={(option) => option.group_type || 'Search'}
          getOptionLabel={(option) => option.name || ''}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              label={selectedCustomer?.id ? 'Customer' : 'All Customers'}
              onChange={handleInputChange}
              name="customer-search"
              placeholder="Search..."
              variant="outlined"
            />
          )}
        />
      </Box>
    )
  );
};

export default React.memo(CustomerHandling);
